import { STICKY_BANNER_RULE_TYPES, BEHAVIOR_MODES, SCROLL_RESOLUTION, STICKY_PAGE_TYPES } from "./stickyBannerConfig.types";
import { mergeStickyBannerConfig } from "./commonConfig";

export const emsatReportsStickyBannerConfig = mergeStickyBannerConfig({
  id: "emsat-reports-page",
  pageType: STICKY_PAGE_TYPES.REPORT_EXTENSION,
  behaviorMode: BEHAVIOR_MODES.SCROLL,
  scrollResolution: SCROLL_RESOLUTION.PRIORITY,
  defaultMessageId: "emsat.default",

  messageRules: [],
  scrollMilestones: [],

  scrollTriggers: [
    {
      id: "emsat-highlights",
      type: STICKY_BANNER_RULE_TYPES.SCROLL_ELEMENT,
      targetElementId: "tte-emsat-highlights",
      priority: 20,
      threshold: 0.12,
      rootMargin: "0px 0px -40% 0px",
      messageId: "emsat.scroll.highlights"
    },
    {
      id: "emsat-near-bottom",
      type: STICKY_BANNER_RULE_TYPES.SCROLL_PERCENT,
      min: 0.85,
      max: 1.01,
      priority: 30,
      messageId: "emsat.scroll.bottom"
    }
  ]
});
